import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class EndItemAllocationError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService) {
    super(reportService, 'End Item Needs Allocation', 'END_ITEM_ALLOCATION', 0, false, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/EndItemAllocationError.ts